var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffab02",
    viewBox: "0 0 24 24",
    id: "menu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "menu-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    x: 7,
    y: 11,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 3,
    y: 16,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 3,
    y: 6,
    rx: 0.94,
    ry: 0.94
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.4c6f7674bbf7a5eb97d2192ac838a30b.svg";
export { ForwardRef as ReactComponent };